import { cn } from '@playbooks/ui/lib/utils';

function Skeleton({ className, 'aria-hidden': ariaHidden = true, ...props }: React.ComponentProps<'div'>) {
	// Theme
	const rootClassName = cn(
		'relative h-4 w-full animate-pulse overflow-hidden rounded-panel bg-surface-hover motion-reduce:animate-none',
		'after:absolute after:inset-0 after:-translate-x-full after:animate-[skeleton-shimmer_1.6s_ease-in-out_infinite] after:bg-linear-to-r after:from-transparent after:via-foreground/10 after:to-transparent',
		'motion-reduce:after:animate-none',
		className,
	);

	// Render
	return <div data-slot='skeleton' aria-hidden={ariaHidden} className={rootClassName} {...props} />;
}

export { Skeleton };
